export default __webpack_public_path__ + "812824f7966e7bf1088637139c669ea5.jpg";